/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Verify_Scanner_Unauthorized_TitleInputs */

const en_verify_scanner_unauthorized_title = /** @type {(inputs: Verify_Scanner_Unauthorized_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scanner Unauthorized`)
};

const es_verify_scanner_unauthorized_title = /** @type {(inputs: Verify_Scanner_Unauthorized_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escáner No Autorizado`)
};

const fr_verify_scanner_unauthorized_title = /** @type {(inputs: Verify_Scanner_Unauthorized_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scanner non autorisé`)
};

const de_verify_scanner_unauthorized_title = /** @type {(inputs: Verify_Scanner_Unauthorized_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scanner nicht autorisiert`)
};

const id_verify_scanner_unauthorized_title = /** @type {(inputs: Verify_Scanner_Unauthorized_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemindai Tidak Sah`)
};

/** @type {(inputs: Verify_Scanner_Unauthorized_TitleInputs) => LocalizedString} */
const ja_verify_scanner_unauthorized_title = en_verify_scanner_unauthorized_title;

/** @type {(inputs: Verify_Scanner_Unauthorized_TitleInputs) => LocalizedString} */
const zh_verify_scanner_unauthorized_title = en_verify_scanner_unauthorized_title;

/** @type {(inputs: Verify_Scanner_Unauthorized_TitleInputs) => LocalizedString} */
const ar_verify_scanner_unauthorized_title = en_verify_scanner_unauthorized_title;

/** @type {(inputs: Verify_Scanner_Unauthorized_TitleInputs) => LocalizedString} */
const it_verify_scanner_unauthorized_title = en_verify_scanner_unauthorized_title;

/** @type {(inputs: Verify_Scanner_Unauthorized_TitleInputs) => LocalizedString} */
const ru_verify_scanner_unauthorized_title = en_verify_scanner_unauthorized_title;

/** @type {(inputs: Verify_Scanner_Unauthorized_TitleInputs) => LocalizedString} */
const pt_verify_scanner_unauthorized_title = en_verify_scanner_unauthorized_title;

/** @type {(inputs: Verify_Scanner_Unauthorized_TitleInputs) => LocalizedString} */
const ko_verify_scanner_unauthorized_title = en_verify_scanner_unauthorized_title;

/**
* | output |
* | --- |
* | "Scanner Unauthorized" |
*
* @param {Verify_Scanner_Unauthorized_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const verify_scanner_unauthorized_title = /** @type {((inputs?: Verify_Scanner_Unauthorized_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verify_Scanner_Unauthorized_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_verify_scanner_unauthorized_title(inputs)
	if (locale === "es") return es_verify_scanner_unauthorized_title(inputs)
	if (locale === "fr") return fr_verify_scanner_unauthorized_title(inputs)
	if (locale === "de") return de_verify_scanner_unauthorized_title(inputs)
	if (locale === "ja") return ja_verify_scanner_unauthorized_title(inputs)
	if (locale === "zh") return zh_verify_scanner_unauthorized_title(inputs)
	if (locale === "ar") return ar_verify_scanner_unauthorized_title(inputs)
	if (locale === "id") return id_verify_scanner_unauthorized_title(inputs)
	if (locale === "it") return it_verify_scanner_unauthorized_title(inputs)
	if (locale === "ru") return ru_verify_scanner_unauthorized_title(inputs)
	if (locale === "pt") return pt_verify_scanner_unauthorized_title(inputs)
	return ko_verify_scanner_unauthorized_title(inputs)
});